import { rendering, warmupData } from 'wix-window-frontend'
import wixLocationFrontend from 'wix-location-frontend'
import { getJSON } from 'wix-fetch'

import JSON5 from 'json5'

import { sendBi } from 'public/bi'
import { sites } from 'public/sites'

// const USER_DETAILS_API_ENDPOINT = 'https://www.wix.com/_api/wix-html-login-webapp/user/getUserDetails'
const USER_DETAILS_API_ENDPOINT = wixLocationFrontend.baseUrl+ '/_api/wix-html-login-webapp/user/getUserDetails'
const MENU_ARIA_LABEL = 'Second navigation'
const DEFAULT_POST_LOGIN_URL = 'https://wix.com/my-account/sites'

$w.onReady(async function () {
    const settings = getSettings()
    setupHeader(settings)

    handleMobileMenu()
    addCustomCSS()
    setHeaderParameters(settings)
})

$widget.onPropsChanged((op, np) => {
    const settings = getSettings()
    setupHeader(settings)
})

const getSettings = () => {
    const { siteId, language } = $widget.props
    const site = sites.find(({ id }) => siteId === id)
    if (site) {
        const { languages } = site
        if (language && languages && Object.keys(languages).length && Object.keys(languages).length > 0 && languages[language]) {
            return { ...site, ...languages[language] }
        } else {
            return site
        }
    } else {
        let menuItems
        try {
            menuItems = JSON5.parse($widget.props.menuItemsStr)
        } catch (error) { menuItems = null }

        const props = Object.assign({}, $widget.props, { menuItems })

        return props
    }
}

let sitePagesMenuItems = null // https://wix.slack.com/archives/CQQ6MNTV5/p1715161206304139

const setupHeader = (settings) => {
    setupMenu(settings)
    setupName(settings)
    setupSearch(settings)
    setupCtas(settings)
    setupLogin(settings)
}

const setupMenu = (settings) => {
    const {
        useSitePages,
        menuItems: menuItemsFromSettings,
    } = settings

    const $desktopMenuNav = $w('#desktopMenuNav')
    const $mobileMenuNav = $w('#mobileMenuNav')

    $desktopMenuNav.accessibility.ariaLabel = MENU_ARIA_LABEL
    // $mobileMenuNav.accessibility.ariaLabel = MENU_ARIA_LABEL

    if (!sitePagesMenuItems) sitePagesMenuItems = $w('#desktopMenuNav').menuItems

    const navMenuItems = (useSitePages || !Array.isArray(menuItemsFromSettings)) ? sitePagesMenuItems : menuItemsFromSettings
    $desktopMenuNav.menuItems = navMenuItems
    $mobileMenuNav.menuItems = navMenuItems

    const getParentItem = (item) => {
        return navMenuItems.find(({ menuItems = [] }) => {
            return menuItems.some(({ label }) => label === item.label)
        })
    }

    const createMenuItemId = ($menu, item) => `${$menu.id}-${item.label}`

    const sendMenuBi = ($menu, item, action) => {
        const id = createMenuItemId($menu, item)
        const itemParent = getParentItem(item)
        sendHeaderActionBi(id, action, item.label, item.link, itemParent?.label)
    }

    $desktopMenuNav.onItemMouseIn(({ item }) => {
        const id = createMenuItemId($desktopMenuNav, item)
        saveMouseInTime(id)
    })
    $desktopMenuNav.onItemClick(({ item }) => {
        $widget.fireEvent('manuItemClick', { item, isMobile: false })
        sendMenuBi($desktopMenuNav, item, 'click')
    })
    $desktopMenuNav.onItemMouseOut(({ item }) => {
        sendMenuBi($desktopMenuNav, item, 'hover')
        const id = createMenuItemId($desktopMenuNav, item)
        clearMouseInTime(id)

    })
    $mobileMenuNav.onItemClick(({ item }) => {
        $widget.fireEvent('manuItemClick', { item, isMobile: true })
        sendMenuBi($mobileMenuNav, item, 'click')
    })

    // const debouncedDesktopSubMenuAction = debounce((item) => {
    //     handleSubMenuOpen(item, false)
    // })
    // $desktopMenuNav.onItemMouseIn(({ item }) => {
    //     const isSubMenu = (item.menuItems.length > 0)
    //     if (isSubMenu) debouncedDesktopSubMenuAction(item)
    // })
    // const openedMobileSubMenus = []
    // $mobileMenuNav.onItemClick(({ item }) => {
    //     handleMenuItemClick(item, true)
    //     const isSubMenu = (item.menuItems.length > 0)
    //     if (isSubMenu) {
    //         const isOpen = openedMobileSubMenus.includes(item.label)
    //         if (isOpen) {
    //             openedMobileSubMenus.splice(openedMobileSubMenus.indexOf(item.label), 1)
    //         } else {
    //             openedMobileSubMenus.push(item.label)
    //             handleSubMenuOpen(item, true)
    //         }
    //     }
    // })
    // const handleSubMenuOpen = (item, isMobile) => {
    //     $widget.fireEvent('subMenuOpen', { item, isMobile })
    //     sendItemClickBi(item.label, item.link)
    // }
}

const setupName = (settings) => {
    const {
        name,
        nameLink
    } = settings

    const $name = $w('#name')
    $name.text = name
    $w('#mobileMenuButton').label = name
    
    if (nameLink) {
        linkTextElement($name, nameLink)
        // $w('#mobileMenuButton').link = nameLink
        $name.onClick(() => {
            $widget.fireEvent('siteNameClick', { label: name, link: nameLink })
            sendHeaderActionBi($name.id, 'click', 'site_title', nameLink)
        })
        $name.onMouseIn(() => { saveMouseInTime($name.id) })
        $name.onMouseOut(() => {
            sendHeaderActionBi($name.id, 'hover', 'site_title', nameLink)
            clearMouseInTime($name.id)
        })
    }

}

const setupSearch = (settings) => {
    const { searchType } = settings

    const $wixSearch = $w('#desktopWixSearchContainer, #mobileWixSearch')

    switch (searchType) {
    case 'wixSearch':
        // $w('#desktopManualSearchInput, #mobileManualSearchInput').collapse()
        $wixSearch.restore()
        $wixSearch.expand()
        break;
    case 'manual':
        $wixSearch.delete()
        // $w('#desktopManualSearchInput, #mobileManualSearchInput').expand()
        break;
    default:
        break;
    }

    $w('#desktopWixSearch, #mobileWixSearch').onClick(event => {
        $widget.fireEvent('wixSearchClick', { isMobile: (event.target.id === 'mobileWixSearch') })
        sendHeaderActionBi(event.target.id, 'click', 'search_cta', null)
    })
    const $desktopWixSearch = $w('#desktopWixSearch')
    $desktopWixSearch.onMouseIn(() => { saveMouseInTime($desktopWixSearch.id) })
    $desktopWixSearch.onMouseOut(() => {
        sendHeaderActionBi($desktopWixSearch.id, 'hover', 'search_cta', null)
        clearMouseInTime($desktopWixSearch.id)
    })

    // $w('#desktopManualSearchInput, #mobileManualSearchInput').onChange(event => {
    //     $widget.fireEvent('manualSearchInput', { phrase: event.target.value })
    // })

    // $w('#desktopManualSearchInput, #mobileManualSearchInput').onKeyPress(event => {
    //     if (event.key == 'Enter') {
    //         $widget.fireEvent('manualSearchSubmit', { phrase: event.target.value })
    //     }
    // })

    // $w('#desktopManualSearchSubmit, #mobileManualSearchSubmit').onClick(event => {
    //     const phrase = (event.target.id === 'desktopManualSearchSubmit') ? $w('#desktopManualSearchInput').value : $w('#mobileManualSearchInput').value
    //     $widget.fireEvent('manualSearchSubmit', { phrase: value })
    // })
}

const setupCtas = (settings) => {
    const {
        mainCta,
        mainCtaLabel,
        mainCtaLink,
        mainCtaTarget,
        mainCtaLogin,

        secondaryCta,
        secondaryCtaLabel,
        secondaryCtaLink,
        secondaryCtaTarget
    } = settings

    const handleCta = (show, $button, $container, label, link, target, eventName, mainCtaLogin) => {
        if (show) {
            $button.label = label

            if (mainCtaLogin) {
                const urlParams = new URLSearchParams(link)
                const postLogin = urlParams.get('postLogin')
                // const postSignUp = urlParams.get('postSignUp')
                $button.link = postLogin || DEFAULT_POST_LOGIN_URL
                $button.target = '_self'

                if (rendering.env === 'browser') {
                    checkIfUserLoggedIn().then(loggedIn => {
                        if (!loggedIn) {
                            $button.link = addOriginUrl(link)
                        }
                    })
                }

            } else {
                const shouldAddLink = (typeof link === 'string' && link.length > 1)
                $button.link = (shouldAddLink) ? link : null

                const sholdAddTarget = (shouldAddLink && typeof target === 'string' && target.charAt(0) === '_')
                if (sholdAddTarget) $button.target = target
                // $button.target = (sholdAddTarget) ? target : null
            }

            const id = $button.id
            $button.onClick(() => {
                $widget.fireEvent(eventName, { label, link })
                sendHeaderActionBi(id, 'click', label, link)
            })
            $button.onMouseIn(() => { saveMouseInTime(id) })
            $button.onMouseOut(() => {
                sendHeaderActionBi(id, 'hover', label, link)
                clearMouseInTime(id)
            })

            $container.restore()
        } else {
            $container.delete()
        }
    }

    // --=[ Main CTA ]=--
    const $mainCTAContainer = $w('#mainCTAContainer, mobileMainCTA1Container, mobileMainCTA2Container')
    const $mainCTA = $w('#mainCTA, #mobileMainCTA1, #mobileMainCTA2')
    handleCta(mainCta, $mainCTA, $mainCTAContainer, mainCtaLabel, mainCtaLink, mainCtaTarget, 'mainCtaClick', mainCtaLogin)

    // --=[ Secondary CTA ]=--
    const $secondaryCTAContainer = $w('#secondaryCTAContainer, #mobileSecondaryCTAContainer')
    const $secondaryCTA = $w('#secondaryCTA, #mobileSecondaryCTA')
    handleCta(secondaryCta, $secondaryCTA, $secondaryCTAContainer, secondaryCtaLabel, secondaryCtaLink, secondaryCtaTarget, 'secondaryCtaClick')

}

const setupLogin = async (settings) => {
    const {
        loginButton,
        loginButtonLink,
        loginButtonLabel
    } = settings

    const $container = $w('#loginContainer, #loginContainerMobile')
    const $button = $w('#login, #loginMobile')
    $container.delete()

    if (loginButton && rendering.env === 'browser') {
        const loggedIn = await checkIfUserLoggedIn()
        if (!loggedIn) {
            $button.target = '_self'
            $button.link = addOriginUrl(loginButtonLink)
            if (loginButtonLabel) $button.label = loginButtonLabel
            $container.restore()

            const { id, label, link } = $button
            $button.onClick(() => {
                // $widget.fireEvent('loginClick', { 'log_in', link })
                sendHeaderActionBi(id, 'click', 'log_in', link)
            })
            $button.onMouseIn(() => { saveMouseInTime(id) })
            $button.onMouseOut(() => {
                sendHeaderActionBi(id, 'hover', 'log_in', link)
                clearMouseInTime(id)
            })
        }
    }
}

const handleMobileMenu = () => {
    if (rendering.env === 'browser') {
        const $mobileMenuButton = $w('#mobileMenuButton')
        const $mobileMenuContainer = $w('#mobileMenuContainer')
        const $mobileMainCTA1Container = $w('#mobileMainCTA1Container')

        $mobileMenuButton.accessibility.ariaExpanded = false

        $mobileMenuButton.onClick(() => {
            if ($mobileMenuContainer.collapsed) {
                $mobileMenuContainer.expand().then(() => {
                    $mobileMenuButton.accessibility.ariaExpanded = true
                    $mobileMenuButton.icon = 'https://static.wixstatic.com/shapes/dea07e_79a25ea316614549ad4396c06a84768b.svg'
                    if (!$mobileMainCTA1Container.deleted) $mobileMainCTA1Container.collapse()
                })
            } else {
                $mobileMenuContainer.collapse().then(() => {
                    $mobileMenuButton.accessibility.ariaExpanded = false
                    $mobileMenuButton.icon = 'https://static.wixstatic.com/shapes/dea07e_bde313f2d4544d179293affb05447d2a.svg'
                    if (!$mobileMainCTA1Container.deleted) $mobileMainCTA1Container.expand()
                })
            }
        })
    }
}

const addCustomCSS = () => {
    const desktopMenuNavId = $w('#desktopMenuNav').uniqueId
    const mobileStickyButtonsContainerId = $w('#mobileStickyButtonsContainer').uniqueId
    // const mobileMenuInnerContainerId = $w('#mobileMenuInnerContainer').uniqueId
    const secondaryHeaderContainerId = $w('#secondaryHeaderContainer').uniqueId

    const css = `
        #${desktopMenuNavId} div[aria-expanded] .wixui-horizontal-menu__item-label::after {
            content: "";
            display: inline-block;
            width: 12px;
            height: 10px;
            margin-left: 14px;
            background: url(https://static.wixstatic.com/shapes/0784b1_cb8967698de043748e44e92e9ecb9e74.svg) no-repeat;
            background-size: contain;
            background-position: center;
        }

        #${desktopMenuNavId} div[aria-expanded="true"] .wixui-horizontal-menu__item-label::after {
            transform:scaleY(-1);
        }

        #${desktopMenuNavId} .wixui-horizontal-menu__item[data-hovered="true"] .wixui-horizontal-menu__item-label {
           font-weight: 700 !important;
        }
        
        #${mobileStickyButtonsContainerId} { position: fixed; bottom: 0px; z-index: 10000 !important; }

        /* header { box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.08); } */
        /* header .kvKTn7 { border-bottom: unset !important; } */

        /* Wix Studio Editor code */
        body.responsive div:has(> section #${secondaryHeaderContainerId} ):not([data-mesh-id="ContainertuckginlineContent-gridContainer"]) {
            position: sticky !important;
            z-index: 9000 !important;
            top: 0px;
        }

        /* Classic Editor code */
        section:has( #${secondaryHeaderContainerId} ) {
            position: sticky !important;
            z-index: 9000 !important;
            top: 0px;
        }

        /* Wix header issue: https://wix.slack.com/archives/C0183G32ZU4/p1724769187594899 */
        /* #SITE_CONTAINER {
            overflow-x: auto;
        } */

        /* WixBlog post issue: https://wix.slack.com/archives/C6GEXMRL0/p1747130257324539 */
        body:has([data-hook="post"]) {
            display: block !important;
        }
    `
    $w('#specialOprations').setAttribute('css', css)
}

const setHeaderParameters = (settings) => {
    if (rendering.env !== 'backend') return

    const { removePricingFromMainMenu, removeGetStartedFromMainHeader, loginButton, comeBackAfterSignOut } = settings
    const hiddenLinks = []
    if (removePricingFromMainMenu) hiddenLinks.push('pricing')
    if (removeGetStartedFromMainHeader) hiddenLinks.push('top-menu-signup')
    if (loginButton) hiddenLinks.push('log_in')

    const headerConfig = {
        stickyBehaviour: 'none', // none, mobile-only, desktop-only
        borderType: 'shadow', // shadow, solid
        hiddenLinks // ['pricing', 'top-menu-signup', 'log_in']
    }

    if (comeBackAfterSignOut) headerConfig.postSignOut = wixLocationFrontend.url

    warmupData.set('headerConfig', headerConfig)
    // $w('#specialOprations').setAttribute('headerconfig', JSON.stringify(headerConfig))
}

const linkTextElement = ($element, link, newTab = false) => {
    const text = $element.text
    const target = (newTab) ? '_blank' : '_self'
    const linkedText = `<a href="${link}" target="${target}">${text}</a>`
    $element.html = $element.html.replace(text, linkedText)
}

// const debounce = (action, delay = 1000) => {
//     let timeout = null

//     return (...args) => {
//         clearTimeout(timeout)
//         timeout = setTimeout(() => {
//             action(...args)
//         }, delay)
//     }
// }

const currentHoveredItems = {}

const saveMouseInTime = (id) => {
    const start = new Date().getTime()
    currentHoveredItems[id] = start
}

const clearMouseInTime = (id) => {
    delete currentHoveredItems[id]
}

const getHoverDuration = (id) => {
    if (!id) return null
    const start = currentHoveredItems[id]
    if (!start) return null
    const end = new Date().getTime()
    return end - start
}

const sendHeaderActionBi = (id, action, buttonName, to = null, submenuTitle = null) => {
    const hover_ms = getHoverDuration(id)
    if (action === 'hover' && !hover_ms) return

    const button_name = snakeCase(buttonName)
    const tab = snakeCase(submenuTitle)
    // snake case the tab

    sendBi('headerAction', {
        sub_tab: null, //(string) - sub tab under which the button is located(usually null)
        tab, //(string) - tab under which the CTA button is located
        button_name, //(string) - the cta button on which the user clicked / hovered
        to, //(string) - the page to which the link redirects the user
        hover_ms, //(numeric) - total hover time in milliseconds
        'from': wixLocationFrontend.url, //(string) - the page in which the user took the action
        action //(string) - hover / click on cta
    })
}

const snakeCase = text => {
    if (!text) return null
    return text.replace(/\W+/g, " ")
        .split(/ |\B(?=[A-Z])/)
        .map(word => word.toLowerCase())
        .join('_')
}

const checkIfUserLoggedIn = () => getJSON(USER_DETAILS_API_ENDPOINT).then(response => response.success)

const addOriginUrl = (link) => {
    const url = new URL(link)
    url.searchParams.set('originUrl', wixLocationFrontend.url)
    return url.toString()
}